// Function to convert any date to US Central Time (CST/CDT)
const convertToUSCentralTime = (date: any) => {
  // Create a copy of the date to avoid modifying the original
  const d = new Date(date);

  // Get the current date in the user's local timezone
  const localDate = new Date();

  // Calculate the offset between the user's timezone and UTC in minutes
  const localOffset = localDate.getTimezoneOffset();

  // Central Time is either UTC-6 (CST) or UTC-5 (CDT) depending on daylight saving
  // First determine if current date would be in DST in US Central Time
  // This is a simplified check - DST in US starts second Sunday in March and ends first Sunday in November
  const year = d.getFullYear();
  //   const month = d.getMonth();
  //   const day = d.getDate();

  // Check if date is within DST period in the US Central Time
  const isDST = () => {
    // DST starts on the second Sunday in March
    const dstStart = new Date(year, 2, 1); // March 1
    const dstStartDay = dstStart.getDay();
    const secondSunday = dstStart.getDate() + (dstStartDay === 0 ? 7 : 14 - dstStartDay);

    // DST ends on the first Sunday in November
    const dstEnd = new Date(year, 10, 1); // November 1
    const dstEndDay = dstEnd.getDay();
    const firstSunday = dstEnd.getDate() + (dstEndDay === 0 ? 0 : 7 - dstEndDay);

    const dstStartDate = new Date(year, 2, secondSunday, 2); // 2 AM on second Sunday in March
    const dstEndDate = new Date(year, 10, firstSunday, 2); // 2 AM on first Sunday in November

    return d >= dstStartDate && d < dstEndDate;
  };

  // Determine the offset for Central Time in minutes (either -360 for CST or -300 for CDT)
  const centralTimeOffset = isDST() ? -300 : -360;

  // Calculate the time difference between the user's timezone and Central Time in milliseconds
  const timeDiff = (localOffset + centralTimeOffset) * 60 * 1000;

  // Adjust the date by adding the time difference
  d.setTime(d.getTime() + timeDiff);

  return {
    date: d,
    isDST: isDST(),
  };
};

// Format date to MM/DD/YY, HH:MM AM/PM CST/CDT format
const formatToUSCentralTime = (date: any) => {
  if (!date) return '';

  // Convert to US Central Time
  const { date: centralDate, isDST } = convertToUSCentralTime(new Date(date));

  // Format the date parts
  const month = (centralDate.getMonth() + 1).toString().padStart(2, '0');
  const day = centralDate.getDate().toString().padStart(2, '0');
  const year = centralDate.getFullYear().toString(); // Last two digits

  // Format the time parts
  let hours = centralDate.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12
  const hoursStr = hours.toString().padStart(2, '0');
  const minutes = centralDate.getMinutes().toString().padStart(2, '0');

  // Determine timezone abbreviation
  const timeZone = isDST ? 'CDT' : 'CST';

  return `${month}/${day}/${year}, ${hoursStr}:${minutes} ${ampm} ${timeZone}`;
};

// Get current US Central Time as a formatted string
const getCurrentUSCentralTime = () => {
  return formatToUSCentralTime(new Date());
};

export { formatToUSCentralTime, getCurrentUSCentralTime, convertToUSCentralTime };
